const Switch = ({ isDefault, onToggle }: { isDefault: boolean; onToggle: (value: boolean) => void }) => {
    const handleLanguage = () => {
        onToggle(!isDefault);
    };

    return (
    <>
        {/* Switch */}
        <label id="switch" className="cursor-pointer hidden xl:block">
            <input type="checkbox" 
                className="sr-only peer" 
                checked={isDefault}
                onChange={handleLanguage}
            />
            <div className="relative border-2 border-solid border-white w-22 h-9 bg-[#BEBFC0] rounded-full">
                <div className={`absolute w-11 h-full flex justify-center items-center bg-[#F06823] rounded-full transition-transform duration-300 ${isDefault ? 'translate-x-11/12' : 'translate-x-0'}`}></div>
                <div className="text-white flex justify-between items-center absolute top-0 left-0 w-full h-full px-2 font-medium">
                    <div className="pl-2">中</div>
                    <div>EN</div>
                </div>
            </div>
        </label>
    </>
  );
};

export default Switch;
